/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFractionClass } from '../../factoriesAny.js';
export var FractionDependencies = {
  createFractionClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFractionClass.generated.js
// module id = 149
// module chunks = 2